import { Component, ElementRef, OnInit } from '@angular/core';
import { ContextService } from '../../services/context.service';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrl: './left-menu.component.scss',
  standalone: false,
})
export class LeftMenuComponent implements OnInit {
  subMenuOpened: number | null = null;
  model: any[] = [];
  constructor(
    public context: ContextService,
    public el: ElementRef,
  ) {}

  navigationItems = [
    {
      label: 'Ordonnancement',
      iconClass: 'pi pi-calendar-minus',
      route: '/scheduling',
    },

    {
      label: 'Hygiène',
      iconClass: 'pi pi-bolt',
      route: '/sanitization',
    },

    {
      label: 'Envoi de fichiers',
      iconClass: 'pi pi-upload',
      route: '/sending-files',
    },
    {
      label: "Traitement d'hygiène",
      iconClass: 'pi pi-step-forward',
      route: '/hygiene-treatment',
    },
    {
      label: 'Paramètres',
      iconClass: 'pi pi-cog',
      route: '/settings',
    },
  ];

  ngOnInit(): void {}
}
